var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99935 1.33337C9.79185 1.33337 11.2539 2.74825 11.3296 4.52211L11.3327 4.66671V6.66671C12.4373 6.66671 13.3327 7.56214 13.3327 8.66671V12.6667C13.3327 13.7713 12.4373 14.6667 11.3327 14.6667H4.66602C3.56145 14.6667 2.66602 13.7713 2.66602 12.6667V8.66671C2.66602 7.56214 3.56145 6.66671 4.66602 6.66671V4.66671C4.66602 2.82576 6.1584 1.33337 7.99935 1.33337ZM11.3327 8.00004H4.66602C4.29783 8.00004 3.99935 8.29852 3.99935 8.66671V12.6667C3.99935 13.0349 4.29783 13.3334 4.66602 13.3334H11.3327C11.7009 13.3334 11.9993 13.0349 11.9993 12.6667V8.66671C11.9993 8.29852 11.7009 8.00004 11.3327 8.00004ZM8.11686 2.6701L7.99935 2.66671C6.93423 2.66671 6.06358 3.49932 6.00274 4.54919L5.99935 4.66671V6.66671H9.99935V4.66671C9.99935 3.60159 9.16674 2.73093 8.11686 2.6701L7.99935 2.66671L8.11686 2.6701Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.fcf4cfd2.svg";
export { ForwardRef as ReactComponent };